import { Tag } from '@cian/components';
import * as React from 'react';

import { IBSCenterTag } from '../../../state/tags/definitions/bs_center';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IBSCenterTagItemProps {
  tag: IBSCenterTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const BSCenterTagItem = (props: IBSCenterTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
